import { http } from "../../core/utils/http";
import axios, { Axios } from "axios";
import authhHeader from "../../core/utils/authh.header";

class Providus {
  constructor(private readonly request: Axios) {}

  private createAxiosInstance() {
    return axios.create({
      baseURL: import.meta.env.VITE_SECOND_BASE_URL, 
      headers: authhHeader(), 
    });
  }

  async getBankss(): Promise<any> {
      const customRequest = this.createAxiosInstance();
    
      return await customRequest
          .get("/Providus/get-banks", {
              headers: authhHeader(),
          })
          .then((res) => {
              return res;
          })
          .catch((err) => {
              return err;
          });
    }

    async getBanks(): Promise<any> {
      const customRequest = this.createAxiosInstance();

      return await customRequest
        .get("/Kredi/bank-list", {
          headers: authhHeader(),
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return err;
        });
    }

    async verifyAccountt(accountNumber: string, bankCode: string): Promise<any> {
        const customRequest = this.createAxiosInstance();
        return await customRequest
          .post("/Providus/nipaccount", {
            accountNumber,
            beneficiaryBank: bankCode,
            userName: "string", 
            password: "string", 
          })
          .then((res) => {
            return res;
          })
          .catch((err) => {
            return err;
          });
      }

      async verifyAccount(accountNumber: string, bankCode: string): Promise<any> {
        const customRequest = this.createAxiosInstance();
        return await customRequest
          .post("/Kredi/beneficiary-name-enquiry", {
            account_no: accountNumber,
            bank_code: bankCode,
          })
          .then((res) => {
            return res;
          })
          .catch((err) => {
            return err;
          });
      }

  }
export default new Providus(http);
